import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import i18n from '../i18n';

/**
 * Custom hook to detect and apply language from URL parameter on initial mount
 * Usage: Call once at the app level (e.g., in App.tsx)
 * Supports ?lang=en, ?lang=de, ?lang=es, ?lang=it
 */
export const useLanguageFromUrl = () => {
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const langParam = queryParams.get('lang');

    if (langParam) {
      const validLanguages = ['en', 'de', 'es', 'it'];
      if (validLanguages.includes(langParam.toLowerCase())) {
        i18n.changeLanguage(langParam.toLowerCase());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run on mount
};
